(function(){
  if(window.__alpInit)return;window.__alpInit=true;
  var store={get:function(k){try{return sessionStorage.getItem(k)}catch(e){return null}},set:function(k,v){try{sessionStorage.setItem(k,v)}catch(e){}}};
  function reveal(){
    var els=document.querySelectorAll('.alp-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return;}
    var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}})},{rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(e){io.observe(e)});
  }
  function addBusinessDays(d,n){var r=new Date(d);while(n>0){r.setDate(r.getDate()+1);var w=r.getDay();if(w!==0&&w!==6)n--;}return r;}
  function eta(){
    document.querySelectorAll('[data-alp-eta]').forEach(function(el){
      var min=parseInt(el.dataset.min||'7',10),max=parseInt(el.dataset.max||'12',10);
      var f=new Intl.DateTimeFormat('fr-CH',{weekday:'short',day:'numeric',month:'long'});
      var now=new Date();
      el.textContent=f.format(addBusinessDays(now,min))+' et le '+f.format(addBusinessDays(now,max));
    });
  }
  function countdown(){
    document.querySelectorAll('[data-alp-deadline]').forEach(function(el){
      if(el.dataset.bound)return;el.dataset.bound='1';
      var t=new Date(el.dataset.alpDeadline+'T23:59:00');
      var wrap=el.closest('[data-alp-cd-wrap]');
      function tick(){var s=Math.floor((t-new Date())/1000);if(s<=0){if(wrap)wrap.hidden=true;return;}
        var d=Math.floor(s/86400),h=Math.floor(s%86400/3600),m=Math.floor(s%3600/60);
        el.innerHTML='<b>'+d+'</b> j <b>'+h+'</b> h <b>'+m+'</b> min';}
      tick();setInterval(tick,30000);
    });
  }
  function offers(){
    document.querySelectorAll('[data-alp-product]').forEach(function(root){
      if(root.dataset.bound)return;root.dataset.bound='1';
      var radios=root.querySelectorAll('input[type=radio][name=id]');
      var labels=document.querySelectorAll('[data-alp-btn-price]');
      var main=root.querySelector('[data-alp-main]');
      var vname=root.querySelector('[data-alp-variant-name]');
      function swap(src){if(!main||!src||main.src===src)return;main.classList.add('is-swapping');var i=new Image();i.onload=function(){main.removeAttribute('srcset');main.src=src;main.classList.remove('is-swapping')};i.src=src;}
      function sync(first){var c=root.querySelector('input[type=radio][name=id]:checked');if(!c)return;labels.forEach(function(l){l.textContent=c.dataset.price});
        root.querySelectorAll('.alp-offer,.alp-swatch').forEach(function(o){o.classList.toggle('is-active',o.contains(c))});
        if(vname&&c.dataset.name)vname.textContent=c.dataset.name;
        if(!first&&c.dataset.img)swap(c.dataset.img);
        if(!first){try{var u=new URL(window.location.href);u.searchParams.set('variant',c.value);window.history.replaceState({},'',u.toString());}catch(e){}}}
      radios.forEach(function(r){r.addEventListener('change',function(){sync(false)})});sync(true);
      var thumbs=root.querySelectorAll('[data-alp-thumb]');
      thumbs.forEach(function(t){t.addEventListener('click',function(){swap(t.dataset.full);thumbs.forEach(function(x){x.classList.remove('is-active')});t.classList.add('is-active');})});
      var bar=document.querySelector('[data-alp-sticky]'),cta=root.querySelector('[data-alp-cta]');
      if(bar&&cta&&'IntersectionObserver' in window){new IntersectionObserver(function(e){bar.classList.toggle('is-visible',!e[0].isIntersecting&&e[0].boundingClientRect.top<0)}).observe(cta);}
      var sb=document.querySelector('[data-alp-sticky-submit]');
      if(sb){sb.addEventListener('click',function(){var f=root.querySelector('form[action*=cart]');if(f){if(f.requestSubmit)f.requestSubmit();else f.submit();}})}
    });
  }
  function popup(){
    var p=document.querySelector('[data-alp-popup]');if(!p||p.dataset.bound)return;p.dataset.bound='1';
    var KEY='alp_popup_seen';
    function open(){if(!p.hidden)return;p.hidden=false;p.classList.add('is-open');store.set(KEY,'1');var i=p.querySelector('input[type=email]');if(i)setTimeout(function(){i.focus({preventScroll:true})},350);}
    function close(){p.hidden=true;p.classList.remove('is-open');store.set(KEY,'1');try{var u=new URL(location.href);if(u.searchParams.has('customer_posted')){u.searchParams.delete('customer_posted');history.replaceState({},'',u.toString())}}catch(e){}}
    p.querySelectorAll('[data-alp-popup-close]').forEach(function(b){b.addEventListener('click',close)});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!p.hidden)close()});
    var cp=p.querySelector('[data-alp-copy]');
    if(cp)cp.addEventListener('click',function(){var c=cp.dataset.alpCopy;function done(){cp.textContent='Code copié'}if(navigator.clipboard){navigator.clipboard.writeText(c).then(done,done)}else done();});
    if(!p.hidden)return;
    if(store.get(KEY))return;
    var delay=(parseInt(p.dataset.delay||'8',10))*1000;
    var t=setTimeout(open,delay);
    document.addEventListener('mouseout',function(e){if(!e.relatedTarget&&e.clientY<=0){clearTimeout(t);open()}},{once:true});
  }
  function init(){reveal();eta();countdown();offers();popup();}
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',function(){var p=document.querySelector('[data-alp-popup]');if(p)delete p.dataset.bound;document.querySelectorAll('[data-alp-product]').forEach(function(r){delete r.dataset.bound});init();});
})();